import { useRef, useState, useEffect } from "react";

const useBooleanFlag = (flag: boolean) => {
  const [hasRequested, setRequested] = useState(false);

  const prevLoadingState = useRef(false);

  useEffect(() => {
    if (prevLoadingState.current && !flag) {
      setRequested(true);
    }
    prevLoadingState.current = flag;
  }, [flag]);

  return hasRequested;
};

export default useBooleanFlag;
